export default "__VITE_PUBLIC_ASSET__fabf014d__"